// This function takes a date string in the format "YYYY-MM-DD HH:MM" and returns a Date object.

export const parseDate = (dateString) => {
    // Split the string into date and time parts
    try {
    const [date, time] = dateString.split(' ');
    const [day, month, year] = date.split('-');
    const [hours, minutes] = time.split(':');
    
    // Create a Date object using the parts
    return new Date(year, month - 1, day, hours, minutes);
    } catch (error) {
        return null;
    }

  };

export const parseDateISO8601 = (dateString) => {
    try {
    // Replace the space with 'T' to make it ISO 8601 compliant
    const isoString = dateString.replace(" ", "T");
    // Create a Date object
    return new Date(isoString);
    } catch (error) {
        return null;
    }
}

export const ISO8601t0DDMMYYYY = (dateString) => {
    try {
    // Replace the space with 'T' to make it ISO 8601 compliant
    const isoString = dateString.replace(" ", "T");
    const date = new Date(isoString);
    // DD-MM-YYYY HH:MM
    return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()} ${date.getHours().toString().padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}`;
    } catch (error) {
        console.log(error);
        return null;
    }
}
